import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { injectIntl } from 'react-intl'
import { Overview } from 'components/misc'
import { MaterialModal } from 'components/layout'
@injectIntl
class MyLeaderModal extends Component {
  static propTypes = {
    leader: PropTypes.object,
    modalId: PropTypes.string,
    intl: PropTypes.object
  }

  render() {
    const { modalId, leader, intl } = this.props

    const placeholder = intl.formatMessage({
      id: 'label.my_award_leader',
      defaultMessage: 'My Award Leader'
    })

    return (
      <MaterialModal.Body
        id={modalId}
        title={`${get(leader, 'person.firstName', placeholder)} ${get(
          leader,
          'person.lastName',
          ''
        )}`}
      >
        <MaterialModal.Content noFooter>
          <Overview
            activityOverview={leader}
            content={[
              {
                id: '00',
                content: get(leader, 'person.email'),
                intlKey: 'label.email',
                label: 'Email',
                ico: 'email'
              },
              {
                id: '01',
                content: get(leader, 'person.phone'),
                intlKey: 'label.phone',
                label: 'Phone',
                ico: 'phone'
              }
            ]}
          />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}

export default MyLeaderModal
